import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    BrowserRouter
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from './App';
import './i18n';

import { useAppStore } from './shared/hooks/useAppStore';
import { debug, getUrlParams } from './shared/lib/general';

import './index.css';

{
    const urlQr = getUrlParams('qr');
    useAppStore.getState().setQrCode(urlQr ?? '');
    debug('initialize sate', 'error');
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <>
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </React.StrictMode>
    </>,
);
